import React from 'react';
import cx from 'classnames';

const CheckboxToggle = ({
  className,
  selected,
  children,
  onChange
}) => (
  <label
    className={cx('checkbox-toggle', className)}
    data-testid={selected ? 'selected-checkbox' : 'checkbox'}
  >
    <input
      className="checkbox-toggle__input"
      type="checkbox"
      checked={selected}
      onChange={onChange}
    />
    <span className={cx('checkbox-toggle__label', {
      'checkbox-toggle__label--selected': selected
    })}>
      {children}
    </span>
  </label>
);

export default CheckboxToggle;
